import AuthLayout from '@authentication/components/AuthLayout';
import LogoutCard from '@authentication/components/molecules/LogoutCard/index.style';
import React from 'react';

function LogoutPage() {
  return (
    <AuthLayout>
      <LogoutCard />
    </AuthLayout>
  );
}

export default LogoutPage;
